import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { preloadCriticalBackdrops } from './utils/preloadImage';

// Précharger les images de fond critiques dès le démarrage
preloadCriticalBackdrops();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Web Vitals désactivé en production pour améliorer les performances
// reportWebVitals();
